module.exports = __webpack_public_path__ + "img/06.497049d7.jpg";